import {
  Button,
  DatePicker,
  Drawer,
  Input,
  Select,
  Space,
  Typography,
  message,
} from 'antd';
import CustomSelect from '../../common/Select/Select';
import { initFilters, yearOptions } from './Invoices';
import { useContext } from 'react';
import { CountryContext } from '../../common/Navigation/Navigation';

const dateOptions = [
  {
    label: 'Today',
    value: 'Today',
  },
  {
    label: 'Yesterday',
    value: 'Yesterday',
  },
  {
    label: 'Last 7 days',
    value: 'Last 7 days',
  },
  {
    label: 'Last 30 days',
    value: 'Last 30 days',
  },
  {
    label: 'This month',
    value: 'This month',
  },
  {
    label: 'Last month',
    value: 'Last month',
  },
  {
    label: 'Custom',
    value: 'Custom',
  },
];

export default function FiltersPane({
  openFilters,
  setOpenFilters,
  filterValues,
  setFilterValues,
  handleApply,
}) {
  const { Text } = Typography;
  const { countries } = useContext(CountryContext);

  // List of filters
  const filters = [
    {
      name: 'Contributor',
      key: 'contributorEmail',
      // type: 'select',
      type: 'text',
      mode: 'multiple',
      value: filterValues['contributorEmail'] || '',
      placeholder: 'Enter contributor email address',
    },
    {
      name: 'Contributor Country',
      key: 'country',
      mode: 'multiple',
      type: 'select',
      options: countries,
    },
    {
      name: 'Invoice Status',
      key: 'invoiceStatus',
      type: 'select',
      mode: 'multiple',
      options: [
        {
          key: 'Ready for Finance Review',
          value: 'Ready for Finance Review',
        },
        {
          key: 'Under Further Review',
          value: 'Under Further Review',
        },
        {
          key: 'Ready for Payout',
          value: 'Ready for Payout',
        },
        {
          key: 'Added to Payout',
          value: 'Added to Payout',
        },
        {
          key: 'Payout Pending',
          value: 'Payout Pending',
        },
        {
          key: 'Payout Failure',
          value: 'Payout Failure',
        },
        {
          key: 'Payout Completed',
          value: 'Payout Completed',
        },
        {
          key: 'Voided',
          value: 'Voided',
        },
        {
          key: 'Ready for Resend',
          value: 'Ready for Resend',
        },
      ],
    },
    {
      name: 'Invoice Period',
      key: 'invoicePeriod',
      type: 'custom',
      renderer: () => (
        <div style={{ display: 'flex', gap: 16 }}>
          <Select
            style={{ flex: 1 }}
            value={filterValues['invoicePeriod.month']}
            mode="multiple"
            placeholder="Enter month"
            onChange={(e) =>
              handleFilterChange(e, 'select', 'invoicePeriod.month')
            }
            options={[
              { key: 'January', value: 'January' },
              { Key: 'February', value: 'February' },
              { key: 'March', value: 'March' },
              { key: 'April', value: 'April' },
              { key: 'May', value: 'May' },
              { key: 'June', value: 'June' },
              { key: 'July', value: 'July' },
              { key: 'August', value: 'August' },
              { key: 'September', value: 'September' },
              { key: 'October', value: 'October' },
              { key: 'November', value: 'November' },
              { key: 'December', value: 'December' },
            ]}
          />
          <Select
            style={{ flex: 1 }}
            value={filterValues['invoicePeriod.year']}
            placeholder="Enter Year"
            onChange={(e) =>
              handleFilterChange(e, 'select', 'invoicePeriod.year')
            }
            options={yearOptions || []}
          />
        </div>
      ),
    },
    // {
    //   name: 'Payout Status',
    //   key: 'payoutStatus',
    //   type: 'select',
    //   mode: 'multiple',
    //   defaultValue: '',
    //   options: [
    //     {
    //       key: 'All',
    //       value: '',
    //       label: 'All',
    //     },
    //     {
    //       key: 'Pending Review',
    //       value: 'Pending Review',
    //     },
    //     {
    //       key: 'Ready for Disbursement',
    //       value: 'Ready for Disbursement',
    //     },
    //     {
    //       key: 'Payout Initiated',
    //       value: 'Payout Initiated',
    //     },
    //     {
    //       key: 'Payout Pending',
    //       value: 'Payout Pending',
    //     },
    //     {
    //       key: 'Payout Failure',
    //       value: 'Payout Failure',
    //     },
    //     {
    //       key: 'Payout Completed',
    //       value: 'Payout Completed',
    //     },
    //     {
    //       key: 'Voided',
    //       value: 'Voided',
    //     },
    //   ],
    // },
    {
      name: 'Invoice Creation Date',
      key: 'invoiceCreationDate',
      defaultValue: 'Last 30 days',
      type: 'custom',
      renderer: () => (
        <div
          style={{
            width: '100%',
            gap: 16,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Select
            style={{ width: '100%' }}
            onChange={(e) =>
              handleFilterChange(e, 'select', 'invoiceCreationDate')
            }
            options={dateOptions}
            value={filterValues['invoiceCreationDate'] || 'Last 30 days'}
            defaultValue={filterValues['invoiceCreationDate'] || 'Last 30 days'}
          />
          {filterValues.invoiceCreationDate === 'Custom' && (
            <DatePicker.RangePicker
              defaultValue={filterValues['invoiceCreationDate.customDates']}
              onChange={(_v, dates) =>
                handleFilterChange(
                  dates,
                  'date_range',
                  'invoiceCreationDate.customDates',
                )
              }
            />
          )}
        </div>
      ),
    },
    {
      name: 'Invoice Last Modified Date',
      key: 'invoiceLastModifiedDate',
      defaultValue: 'Last 30 days',
      type: 'custom',
      renderer: () => (
        <div
          style={{
            width: '100%',
            gap: 16,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Select
            style={{ width: '100%' }}
            onChange={(e) =>
              handleFilterChange(e, 'select', 'invoiceLastModifiedDate')
            }
            options={dateOptions}
            value={filterValues['invoiceLastModifiedDate'] || 'Last 30 days'}
            defaultValue={
              filterValues['invoiceLastModifiedDate'] || 'Last 30 days'
            }
          />
          {filterValues.invoiceLastModifiedDate === 'Custom' && (
            <DatePicker.RangePicker
              defaultValue={filterValues['invoiceLastModifiedDate.customDates']}
              onChange={(_v, dates) =>
                handleFilterChange(
                  dates,
                  'date_range',
                  'invoiceLastModifiedDate.customDates',
                )
              }
            />
          )}
        </div>
      ),
    },
    {
      name: 'Notes',
      key: 'notes',
      type: 'custom',
      renderer: () => (
        <div style={{ display: 'flex', gap: 16 }}>
          <Select
            style={{ flex: 1 }}
            defaultValue={'Contains'}
            value={filterValues['notes.type'] || 'Contains'}
            onChange={(e) => handleFilterChange(e, 'select', 'notes.type')}
            options={[
              { key: 'Contains', value: 'Contains' },
              { key: 'Does not contain', value: 'Does not contain' },
            ]}
          />
          <Input
            value={filterValues['notes.value'] || ''}
            onChange={(e) =>
              handleFilterChange(e.target.value, 'text', 'notes.value')
            }
            style={{ flex: 1 }}
          />
        </div>
      ),
    },
  ];

  const handleReset = () => {
    setFilterValues(initFilters);
  };

  const handleFilterChange = (v, _type, key) => {
    setFilterValues({
      ...filterValues,
      [key]: v,
    });
  };

  const handleApplyFilter = () => {
    const month = filterValues['invoicePeriod.month']?.length || 0;
    const year = filterValues['invoicePeriod.year'] || '';
    if (month !== 0 && year === '') {
      message.error('Please select invoice period year to Apply filters');
    } else if (month === 0 && year !== '') {
      message.error('Please select invoice period month to Apply filters');
    } else {
      handleApply();
    }
  };

  return (
    <Drawer
      title={`Filters`}
      placement="right"
      size={400}
      onClose={() => setOpenFilters(false)}
      open={openFilters}
      extra={
        <Space>
          <Button onClick={() => handleReset()}>Reset</Button>
          <Button type="primary" onClick={() => handleApplyFilter()}>
            Apply
          </Button>
        </Space>
      }
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '18px' }}>
        {filters.map((filter) => {
          return (
            <div key={filter.name} style={{ display: 'block' }}>
              <Text key={filter.name} style={{ fontSize: '16px' }}>
                {filter.name}
              </Text>
              {filter.type === 'text' ? (
                <Input
                  key={filter.name}
                  placeholder={filter.name}
                  defaultValue={filter.defaultValue}
                  value={filterValues[filter.key] || filter.defaultValue}
                  onChange={(e) =>
                    handleFilterChange(e.target.value, 'text', filter.key)
                  }
                />
              ) : filter.type == 'select' ? (
                <CustomSelect
                  mode={filter.mode}
                  key={filter.name}
                  disabled={filter.disabled}
                  options={filter.options || []}
                  defaultValue={filterValues[filter.key] || filter.defaultValue}
                  placeholder={filter.name}
                  value={filterValues[filter.key] || filter.defaultValue}
                  onChange={(e) => handleFilterChange(e, 'select', filter.key)}
                />
              ) : filter.type == 'custom' ? (
                filter.renderer()
              ) : null}
            </div>
          );
        })}
      </div>
    </Drawer>
  );
}
